/**
 * LeaveTypeSelect
 *
 * A leave type picker, each type shown as the planning shows it: a dot and the label in the
 * type's own colour. Shared by the Congés and arrêt de travail forms so the three read alike.
 */
import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { formFieldSx } from "../popups/FormDialog";

/** One leave type: a dot and its label, in the type's colour. */
export function LeaveTypeOption({ sample }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8, color: sample.color || "inherit" }}>
      <span style={{
        width: 10, height: 10, borderRadius: "50%", flexShrink: 0,
        backgroundColor: sample.color || "transparent",
      }} />
      {sample.label}
    </span>
  );
}

/**
 * @param {*} props.value - the selected sample leave's id
 * @param {Function} props.onChange - called with the selected sample leave (or null)
 * @param {Array} props.options - sample leaves ({ id, label, color })
 */
export default function LeaveTypeSelect({ value, onChange, options, error, helperText, disabled }) {
  const list = options || [];
  return (
    <TextField
      select
      fullWidth
      size="small"
      value={value ?? ""}
      onChange={(e) => onChange(list.find((sample) => sample.id === e.target.value) || null)}
      error={error}
      helperText={helperText}
      disabled={disabled}
      sx={formFieldSx}
      SelectProps={{
        renderValue: (id) => {
          const sample = list.find((s) => s.id === id);
          return sample ? <LeaveTypeOption sample={sample} /> : "";
        },
      }}
    >
      {list.map((sample) => (
        <MenuItem key={sample.id} value={sample.id}><LeaveTypeOption sample={sample} /></MenuItem>
      ))}
    </TextField>
  );
}
